var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mt-10",attrs:{"id":"order-label-print"}},[_c('div',[_c('qrcode-vue',{staticClass:"w-full h-full",attrs:{"level":"L","size":"260","value":_vm.storageUnit ? _vm.storageUnit.ops_id : ''}})],1),_c('p',{staticClass:"font-medium text-center text-4xl"},[_vm._v(_vm._s(_vm.storageUnit ? _vm.storageUnit.ops_id : ''))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }